// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_4a58f2c","container":"_f665563","innerContainer":"_2e2826d","mobileClickFeedback":"_8ce6729"};